import config from 'config';
import _ from 'lodash';
import { action, observable } from 'mobx';
import reqwest from 'reqwest';

const environments = {
  LOCAL:   'LOCAL',
  DEV:     'DEV',
  STA:     'STA',
  LIVE:    'LIVE',
  DEVLIVE: 'DEVLIVE',
  BETA:    'BETA',
};

/**
 * API class - handels all api related stuff
 */
class API {
  @observable token = '';

  mediahubId = '';

  constructor() {
    const env       = this.getEnv();
    this.mediahubId = _.isEqual(env, 'DEV')
      ? config.mediahubIdDev
      : config.mediahubId;
  }

  /**
   * Set the token
   */
  @action
  setToken(token = '') {
    this.token = 'token=' + token;
  }

  /**
   * apiPath - establish correct api path
   * @resource (String) - string indicating the resource
   * @params (Object) - object containng other params
   */
  apiPath(resource, params) {
    // Vars from params
    const channelId  = _.result(params, 'channelId', '');
    const auth       = _.result(params, 'auth');
    const skip       = _.result(params, 'skip');
    const limit      = _.result(params, 'limit', '100');
    const directLink = _.result(params, 'directLink', '');
    const language   = 'en,de,silent';


    switch(resource) {
      case 'init':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/config';
      case 'config':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/config';
      case 'mediahub':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/channels';
      case 'channel':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/' + channelId;
      case 'search':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/search';
      case 'deliverItems':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/deliverItems';
      case 'deliverThumbs':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/signedMediaUrls';
      case 'directLink':
        return this.host() + '/v5/mediahub/' + this.mediahubId + '/directLink?directLink=' + directLink;
      // case 'feature':
      //   return this.host() + '/v2/mediahub/' + this.mediahubId + '/' + channelId + '?audioLanguage=' + language;
      // case 'player':
      //   return this.host() + '/v2/mediacontainer/de/' + this.mediahubId;
      // case 'downloadTracker':
      //   return this.host('stats') + '/v2/downloads/tracker';
      // case 'rating':
      //   return this.host() + '/v2/rating';
      default:
        throw new Error('no valid resource!');
    }
  }

  /**
   * Method for getting variables form URL
   */
  getUrlVars() {
    const vars  = {};
    const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    return vars;
  }

  getEnvFromHostname(host) {
    // turn this line on for developing, BUT don't forget to disable again after pushing:
    // return environments.LIVE;

    if(host.indexOf('dev-mediahub') > -1) {
      return environments.DEV;
    }
    if(host.indexOf('tc-mh-3796-dev') > -1) {
      return environments.LIVE;
    }
    if(host.indexOf('localhost') > -1) {
      return environments.DEV;
    }
    return environments.LIVE;
  }

  /**
   * Method for establishing environment
   */
  getEnv() {
      return environments.LIVE;
    const envFromUrl  = this.getUrlVars().env && this.getUrlVars().env.toUpperCase();
    const envFromHost = this.getEnvFromHostname(window.location.hostname);

    const env  = envFromUrl || envFromHost;
    const envs = Object.keys(environments);

    if(envs.indexOf(env) < 0) {
      alert(env + ' is not a valid environment! ' + env + ' has to be in ' + envs.toString());
    }


    return env;
  }

  /**
   * Method for establishing host
   * @name (String) - name of host, either 'api' (default) or 'stats'
   */
  host(name) {
    name = name || 'api';

    const env   = this.getEnv();
    const hosts = {
      api:   {
        LOCAL:   '//apiobs.admiralcloud.com',
        DEV:     '//apidev.admiralcloud.com',
        STA:     '//apifra.admiralcloud.com',
        LIVE:    '//api.admiralcloud.com',
        DEVLIVE: '//apiobs.admiralcloud.com',
        BETA:    '//betaapi.admiralcloud.com',
      },
      stats: {
        LOCAL: '//localhost:3000',
        DEV:   '//statisticdev.admiralcloud.com',
        STA:   '//statisticdev.admiralcloud.com',
        LIVE:  '//statistic.admiralcloud.com',
        BETA:  '//statistic.admiralcloud.com',
      },
    };

    const availableHosts = Object.keys(hosts);
    const chosenHost     = availableHosts.indexOf(name) < 0
      ? availableHosts[0]
      : name;

    // We want to run on https
    return 'https:' + hosts[chosenHost][env];
  }

  /**
   * Wrapper for API requests
   * @method    (String) - request method like get, post, etc...
   * @resource  (String) - string indicating the resource
   * @params    (Object) - object containng other params
   */
  apiRequest(method, resource, params) {
    const token = _.indexOf(['directLink'], resource) < 0
      ? `?${this.token}`
      : `&${this.token}`;
    const path  = config.includeAuthToken
      ? this.apiPath(resource, params) + token
      : this.apiPath(resource, params);
    const data  = _.result(params, 'data');

    const requestParams = {
      method:      method,
      url:         path,
      type:        'json',
      contentType: 'application/json',
      crossOrigin: true,
    };

    if(!!data) {
      requestParams.data = JSON.stringify(data);
    }

    return reqwest(requestParams);
  }

  /**
   * Method for GET api requests,
   * only for convenience.
   */
  get(...params) {
    return this.apiRequest('get', ...params);
  }

  /**
   * Method for POST api requests,
   * only for convenience.
   */
  post(...params) {
    return this.apiRequest('post', ...params);
  }

}


const api = new API();
export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js